__turbopack_context__.v({
  "active": "LoadingBar-module-scss-module__3Bqw4a__active",
  "loader": "LoadingBar-module-scss-module__3Bqw4a__loader",
  "loading": "LoadingBar-module-scss-module__3Bqw4a__loading",
});
